import { defineMessages } from "react-intl";

import { node as ekg } from "src/modules/basic-health/forms/current-cardiological-state/ekg";
import { node as heartFailureMedicalTherapy } from "src/modules/basic-health/forms/current-cardiological-state/heartFailureMedicalTherapy";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.current_cardiological_state",
		defaultMessage: "Aktuális kardiológiai állapot"
	}
});

export const node: ParentNode = {
	id: "basic-health-current-cardiological-state",
	value: { type: "wizard", title: messages.title },
	children: [ekg, heartFailureMedicalTherapy]
};
